import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../components/HomeView.vue'

import MenuView from '../components/Menu/MenuView.vue'
import MenuEntryView from '../components/Menu/MenuEntryView.vue'
import AppointmentView from '../components/Appointment/AppointmentView.vue'
import EventView from '../components/Event/EventView.vue'
import VideoCallView from '../components/VideoCallView.vue'
import FeuchterTVView from '../components/FeuchterTVView.vue'
import MenuPlayoutLayout from '../components/Playout/MenuPlayoutLayout.vue'
import EventPlayoutView from '../components/Playout/EventPlayoutLayout.vue'
import HeadlineView from '../components/Playout/HeadlinePlayoutLayout.vue'
import NewsPlayoutView from '../components/Playout/NewsPlayoutLayout.vue'
import NewsView from '../components/News/NewsView.vue'
import NewsEntryView from '../components/News/NewsEntryView.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/menu',
        name: 'menu',
        component: MenuView,
        meta: {
            breadCrumb: [
                {
                    text: 'nav.home',
                    disabled: false, 
                    icon: 'mdi-home-outline', 
                    home: true, 
                    href: '/'
                },
                {
                    text: 'nav.menu',
                    icon: 'mdi-silverware-fork-knife', 
                    home: false, 
                    disabled: true, 
                    href: 'menu'
                }
            ]
        }
    },
    {
        path: '/menu/:date',
        name: 'menuEntry',
        component: MenuEntryView,
        meta: {
            breadCrumb: [
                {
                    text: 'nav.home',
                    disabled: false, 
                    home: true, 
                    icon: 'mdi-home-outline', 
                    href: '/'
                },
                {
                    text: 'nav.menu',
                    icon: 'mdi-silverware-fork-knife', 
                    home: false, 
                    disabled: false, 
                    href: '/menu'
                },
                {
                    text: 'Speiseplan', //Text wird in Komponente ersetzt
                    home: false, 
                    disabled: true, 
                    href: 'menu'
                }
            ]
        }
    },
    {
        path: '/news',
        name: 'news',
        component: NewsView,
        meta: {
            breadCrumb: [
                {
                    text: 'nav.home',
                    disabled: false, 
                    home: true, 
                    icon: 'mdi-home-outline', 
                    href: '/'
                },
                {
                    text: 'nav.news',
                    home: false, 
                    icon: 'mdi-bullhorn-outline', 
                    disabled: true
                }
            ]
        }
    },
    {
        path: '/news/:newsID',
        name: 'newsEntry',
        component: NewsEntryView,
        meta: {
            breadCrumb: [
                {
                    text: 'nav.home',
                    disabled: false, 
                    home: true, 
                    icon: 'mdi-home-outline', 
                    href: '/'
                },
                {
                    text: 'nav.news',
                    home: false, 
                    icon: 'mdi-bullhorn-outline',
                    href: '/news'
                },
                {
                    text: 'nav.news',
                    home: false, 
                    disabled: true
                }
            ]
        }
    },
    {
        path: '/appointment/:date',
        name: 'appointment',
        component: AppointmentView,
        meta: {
            breadCrumb: [
                {
                    text: 'nav.home',
                    disabled: false, 
                    icon: 'mdi-home-outline', 
                    home: true, 
                    href: '/'
                },
                {
                    text: 'nav.event',
                    icon: 'mdi-notebook-outline', 
                    home: false, 
                    disabled: true, 
                    href: 'event'
                }
            ]
        }
    },
    {
        path: '/event/:date',
        name: 'event',
        component: EventView,
        meta: {
            breadCrumb: [
                {
                    text: 'nav.home',
                    disabled: false, 
                    icon: 'mdi-home-outline', 
                    home: true, 
                    href: '/'
                },
                {
                    text: 'nav.event',
                    icon: 'mdi-calendar-month-outline', 
                    home: false, 
                    disabled: true, 
                    href: 'event'
                }
            ]
        }
    },
    {
        path: '/video-call',
        name: 'video-call',
        component: VideoCallView
    },
    {
        path: '/feuchter-tv',
        name: 'feuchter-tv',
        component: FeuchterTVView
    },
    
    {
        path: '/playout/menu',
        name: 'menu-playout',
        component: MenuPlayoutLayout,
        meta: { layout: 'menu-playout'}
    },
    {
        path: '/playout/event',
        name: 'event-playout',
        component: EventPlayoutView,
        meta: { layout: 'event-playout'}
    },
    {
        path: '/playout/news',
        name: 'news-playout',
        component: NewsPlayoutView,
        meta: { layout: 'news-playout'}
    },
    {
        path: '/playout/headline',
        name: 'playout-headline',
        component: HeadlineView,
        meta: { layout: 'headline-playout'}
    },
]

const router = new VueRouter({
  routes
})

export default router
